import { isNative } from "./capacitor";

const toB64 = (blob) =>
  new Promise((res, rej) => {
    const r = new FileReader();
    r.onloadend = () => res(String(r.result).split(",")[1]);
    r.onerror = rej;
    r.readAsDataURL(blob);
  });

const webDownload = (blob, name) => {
  const obj = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: obj, download: name });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(obj), 4000);
};

// يشارك الملف نفسه باسم واضح (لا رابط طويل، ولا عنوان مكرّر) على الجوال والويب.
export const shareFile = async (url, filename) => {
  const blob = await (await fetch(url)).blob();
  if (isNative()) {
    const { Filesystem, Directory } = await import("@capacitor/filesystem");
    const w = await Filesystem.writeFile({ path: filename, data: await toB64(blob), directory: Directory.Cache, recursive: true });
    const { Share } = await import("@capacitor/share");
    await Share.share({ files: [w.uri] });
    return;
  }
  const file = new File([blob], filename, { type: blob.type || "application/octet-stream" });
  if (navigator.canShare?.({ files: [file] })) {
    try { await navigator.share({ files: [file] }); return; } catch { /* أُلغيت */ }
  }
  webDownload(blob, filename);
};
